const LoadingRow = ({ columnCount = 0 }) => (
  <tr>
    {Array(columnCount)
      .fill(0)
      .map((_, index) => (
        <td key={index} className="px-4 sm:px-6 py-4 whitespace-nowrap">
          <div className="animate-pulse h-4 bg-gray-200 rounded"></div>
        </td>
      ))}
  </tr>
);

const LoadingRows = ({ columnCount = 0, rowCount = 5 }) => (
  <>
    {Array(rowCount)
      .fill(0)
      .map((_, index) => (
        <LoadingRow key={index} columnCount={columnCount} />
      ))}
  </>
);

export default LoadingRows;
